import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  return <AnimatePresence data-id="element-208">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-209">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="absolute inset-0 bg-black/50" onClick={onClose} data-id="element-210" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25
      }} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[80vh] flex flex-col overflow-hidden z-10" data-id="element-211">
            <div className="flex items-center justify-between p-5 border-b border-gray-200" data-id="element-212">
              <h3 className="font-serif text-xl font-bold text-forest-dark" data-id="element-213">
                {title}
              </h3>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-lg hover:bg-gray-100" aria-label="Cerrar" data-id="element-214">
                <XIcon size={20} data-id="element-215" />
              </button>
            </div>
            <div className="p-5 overflow-y-auto text-sm text-gray-700 leading-relaxed space-y-4" data-id="element-216">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}